import { motion } from "framer-motion";

const SectionHeading = ({ number, title, accent, subtitle, id }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    className="mb-14 md:mb-20"
    data-testid={id ? `${id}-heading` : undefined}
  >
    <p className="text-xs uppercase tracking-[0.3em] font-bold text-tealbrand mb-4">
      {number}
    </p>
    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight text-navy max-w-3xl">
      {title} {accent && <span className="text-tealbrand">{accent}</span>}
    </h2>
    {subtitle && (
      <p className="mt-4 text-base sm:text-lg text-slate-600 font-medium leading-relaxed max-w-2xl">
        {subtitle}
      </p>
    )}
  </motion.div>
);

export default SectionHeading;
